import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Stack, Typography } from '@mui/material';

type MissingCandidateAvailabilityTokenAlertProps = {
  onAppendAndContinue: () => void;
  goBack: () => void;
};

const MissingCandidateAvailabilityTokenAlert = ({
  onAppendAndContinue,
  goBack,
}: MissingCandidateAvailabilityTokenAlertProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open
      maxWidth="xs"
      title={t('hiring-dashboard-candidates:candidates.missingToken.title')}
      submitOptions={{
        label: t('hiring-dashboard-candidates:candidates.missingToken.appendAndSend'),
        onClick: onAppendAndContinue,
      }}
      cancelOptions={{
        label: t('hiring-dashboard-common:common.cancel'),
        onClick: goBack,
      }}
    >
      <Stack spacing={2}>
        <Typography fontWeight={400}>
          {t('hiring-dashboard-candidates:candidates.missingToken.body', { token: '{{CANDIDATE_AVAILABILITY_URL}}' })}
        </Typography>
        <Typography fontWeight={600}>{t('hiring-dashboard-candidates:candidates.missingToken.appendInfo')}</Typography>
        <Typography variant="body2" color="text.secondary" fontWeight={400}>
          {t('hiring-dashboard-candidates:candidates.missingToken.exampleLink')}
        </Typography>
      </Stack>
    </Dialog>
  );
};

export default MissingCandidateAvailabilityTokenAlert;
